import { render, staticRenderFns } from "./EnrollAdmin.vue?vue&type=template&id=3405f87a&scoped=true&"
import script from "./EnrollAdmin.vue?vue&type=script&lang=js&"
export * from "./EnrollAdmin.vue?vue&type=script&lang=js&"
import style0 from "./EnrollAdmin.vue?vue&type=style&index=0&id=3405f87a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405f87a",
  null
  
)

export default component.exports